import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { BciSidebarService } from '@bci-web-core/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { WarningDialog } from 'src/app/shared/index';
import { AuthService } from 'src/app/services/auth.service';
import { ButtonConfig } from 'src/app/models/button.component.model';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private sidebarService: BciSidebarService, private router: Router, public dialog: MatDialog) { }

	isDialogOpened = false;
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const started = Date.now();
    // return next.handle(request).pipe(
    //   catchError((error: HttpErrorResponse) => {
    //     if (error.status !== 401) {
    //       // 401 handled in auth.interceptor
    //       console.error('after:' + error.message);
    //     }
    //     return throwError(error);
    //   })
    // );
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && error.error !== undefined) {
          const message = error.error.message.trim().toLowerCase();
          if (message.includes('full authentication is required to access this resource')
            || message.includes('invalid access token')
          ) {
            if (this.router.url !== '/') {
              if (this.dialog.openDialogs.length === 0) {
                this.isDialogOpened = true;
                const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
                dialogRef.componentInstance.confirmMessage = "Your session has been expired! Please login again to continue.";
                dialogRef.componentInstance.buttonConfig = [new ButtonConfig('Close', false, true, () => dialogRef.close(false))];
                dialogRef.afterClosed().subscribe(() => {
                  console.error('after:' + error.message);
                  console.log("Access token expired !");
                  this.isDialogOpened = false;
                  this.authService.logout();
                  this.sidebarService.setSidebarVisibility(false);
                  this.router.navigate(['/']);
                });
              }
            }
            return;
          }
        }
        return throwError(error);
      })
    );
  }
}
